import React from 'react';

// type QuizProps = {
//     quiz_no: number
//     tree: TreeNode
//     answer1: boolean
//     answer2: boolean
//     handleChoice: Function
// }

const QuizComponent = ({ quiz_no, tree, answer1, answer2, handleChoice }) => {

    //문제지 출력
    const GetQuestionString = (quiz_no) => {
        if (quiz_no === 1) return '일정 없는 주말, 내 귀염둥이랑 오랜만에 외출! 어디로 가지!?'
        else if (quiz_no === 2) return '매일매일 다이어리를 쓰는 나! 나만의 다이어리는 어떤 모습?'
        else if (quiz_no === 3) return '두근두근 반려동물과의 첫만남. 어떻게 해야 집사 노릇을 잘할까?'
        else if (quiz_no === 4) return '내 방을 예쁘게 꾸며보자! 어떤 가구를 선택해볼까?'
        else if (quiz_no === 5) return '집안일 하는 도중 반려동물의 깜짝 애교! 나의 반응은?'
        else if (quiz_no === 6) return '반려동물이 갑자기 기운도 없고 축 처져 있다. 어떡하지?'
        else if (quiz_no === 7) return '오늘은 친구랑 밤샘 게임하는 날! 어떻게 게임을 즐길까?'
        else if (quiz_no === 8) return '오랜만에 친구들이랑 캠핑 가는 날! 가서 뭐하고 놀까?'
    }

    //답변 출력 비구조화 return
    const GetAnswerString = (quiz_no) => {
        let answer1 = ''
        let answer2 = ''

        if (quiz_no === 1) {
            answer1 = '각 잡고 나가볼까! 거리 상관 없이 핫플레이스 검색!'
            answer2 = '멀리 가는 건 귀찮아~ 동네 한바퀴 마실 돌기!'
        }
        else if (quiz_no === 2) {
            answer1 = '스티커와 사진이 빼곡하고 이쁘게 꾸며진 다이어리'
            answer2 = '일정과 시간이 표 형태로 작성된 스케쥴러'
        }
        else if (quiz_no === 3) {
            answer1 = '나는 프로 검색러! 주변에 물어보거나 인터넷에 검색하다.'
            answer2 = '펫을 키우는 사람들이 최고지! 펫 관련 모임에 가입한다.'
        }
        else if (quiz_no === 4) {
            answer1 = '실용적인게 최고야! 내 방에 맞고 기능에 충실한 가구들'
            answer2 = '무조건 귀엽고 이쁜거! 디자인 예쁜 가구들'
        }
        else if (quiz_no === 5) {
            answer1 = '오구오구 이쁜 내새끼. 애교를 받아주고 집안일은 잠시 미룬다.'
            answer2 = '하던 일은 마저 끝내야지! 애교를 적당히 받아주고 집안일을 한다'
        }
        else if (quiz_no === 6) {
            answer1 = '혹시 무슨 병이 걸린건 아니지? 증상을 세심하게 살펴본다'
            answer2 = '산책갈까? 기운이 날만한 걸 시도한다'
        }
        else if (quiz_no === 7) {
            answer1 = '같이 게임하는 건 즐거워! 같이 재밌는 게임을 하는 것만으로 재밌다.'
            answer2 = '게임을 하면 이겨야지! 친구를 이기기 위해 기를 쓴다.'
        }
        else if (quiz_no === 8) {
            answer1 = '캠핑하면 모닥불이지! 모닥불 앞에서 불멍~'
            answer2 = '밖에 나왔으면 돌아다녀야지! 캠핑장 주변 산책하기~ '
        }

        return { answer1, answer2 }
    }

    //답변 출력
    const GetAnswer = (quiz_no, answer_no) => {
        const { answer1, answer2 } = GetAnswerString(quiz_no)
        if (answer_no === 1) return answer1
        else if (answer_no === 2) return answer2
    }

    return (
        < div className={`quiz q${quiz_no}`} >
            <h2>
                <span>{`Q.${quiz_no}`}</span>
                {GetQuestionString(quiz_no)}
            </h2>
            <div
                className={`box ${answer1 ? 'choice' : ''}`}
                onClick={() => handleChoice(tree.left.value)}
            >
                {GetAnswer(quiz_no, 1)}
            </div>
            <div
                className={`box ${answer2 ? 'choice' : ''}`}
                onClick={() => handleChoice(tree.right.value)}
            >
                {GetAnswer(quiz_no, 2)}
            </div>
        </div >
    )
}

export default QuizComponent